import { gql } from "@apollo/client";

export const GET_INBOX_CONFIG = gql`
	query getInboxConfig($inboxId: Int!) {
		msgbox_InboxConfib(where: { InboxId: { _eq: $inboxId } }) {
			CRMEmail
			CRMIntegration
			InboxId
			ReapitCustomerId
			ReapitNegotiatorId
			ReapitOfficeId
			ReapitJournalType
			BullhornClientId
			BullhornUsername
			BullhornPassword
			BullhornClientSecret
			CRMFrequency
			AltoAgencyRef
			IsVincereConnected
			IsJobAdderConnected
			EployTenant
			EployUserId
			EployClientId
			EployClientSecret
		}
	}
`;

export const UPDATE_INBOX_CONFIG = gql`
	mutation updateInboxConfig(
		$inboxId: Int!
		$crmEmail: String
		$crmIntegration: String
		$reapitCustomerId: String
		$reapitNegotiatorId: String
		$reapitOfficeId: String
		$reapitJournalType: String
		$autoConversationAssign: Boolean
		$bullhornClientId: String
		$bullhornUsername: String
		$bullhornPassword: String
		$bullhornClientSecret: String
		$crmFrequency: String
		$altoAgencyRef: String
		$eployTenant: String
		$eployUserId: String
		$eployClientId: String
		$eploySecret: String
	) {
		update_msgbox_InboxConfib(
			where: { InboxId: { _eq: $inboxId } }
			_set: {
				CRMEmail: $crmEmail
				CRMIntegration: $crmIntegration
				ReapitCustomerId: $reapitCustomerId
				ReapitNegotiatorId: $reapitNegotiatorId
				ReapitOfficeId: $reapitOfficeId
				ReapitJournalType: $reapitJournalType
				BullhornClientId: $bullhornClientId
				BullhornUsername: $bullhornUsername
				BullhornPassword: $bullhornPassword
				BullhornClientSecret: $bullhornClientSecret
				CRMFrequency: $crmFrequency
				AltoAgencyRef: $altoAgencyRef
				EployTenant: $eployTenant
				EployUserId: $eployUserId
				EployClientId: $eployClientId
				EployClientSecret: $eploySecret
			}
		) {
			affected_rows
			returning {
				CRMEmail
				CRMIntegration
				InboxId
				ReapitCustomerId
				ReapitNegotiatorId
				ReapitOfficeId
				ReapitJournalType
				BullhornClientId
				BullhornUsername
				BullhornPassword
				BullhornClientSecret
				CRMFrequency
				AltoAgencyRef
				EployTenant
				EployUserId
				EployClientId
				EployClientSecret
			}
		}
	}
`;

export const INSERT_INBOX_CONFIG = gql`
	mutation insertInboxConfig($inboxId: Int!) {
		insert_msgbox_InboxConfib_one(
			object: {
				# OrganisationId: 1
				InboxId: $inboxId
				# CRMEmail: "agnieszka@quidvista.com"
				# CRMFromEmail: String
				# CRMIntegration: String
				# ReapitCustomerId: String
				# ReapitNegotiatorId: String
				# ReapitOfficeId: String
			}
		) {
			CRMEmail
			# CRMFromEmail
			# CRMIntegration
			# InboxConfigId
			# OrganisationId
			# ReapitCustomerId
			# ReapitNegotiatorId
			# ReapitOfficeId
		}
	}
`;


export const GET_ORG_ID = gql`
	query getOrgId {
		msgbox_Organisation {
			OrganisationId
		}
	}
`;


export const UPDATE_VINCERE_CONNECTED = gql`
	mutation updateInboxConfig(
		$inboxId: Int!
		$IsVincereConnected: Boolean
	) {
		update_msgbox_InboxConfib(
			where: { InboxId: { _eq: $inboxId } }
			_set: {
				IsVincereConnected: $IsVincereConnected
			}
		) {
			affected_rows
			returning {
				IsVincereConnected
			}
		}
	}
`;